import { useCallback } from 'react';

// Module-level flag to avoid registering duplicate close listeners across re-renders
let widgetCloseListenerRegistered = false;

const registerCloseListener = () => {
    if (widgetCloseListenerRegistered) return;
    widgetCloseListenerRegistered = true;

    window.HubSpotConversations?.on('widgetClosed', () => {
        window.HubSpotConversations?.widget.remove();
        widgetCloseListenerRegistered = false;
    });
};

/**
 * Loads the widget (if not yet loaded) and opens the chat panel.
 *
 * widget.load({ widgetOpen: true }) is unreliable — the SDK has a known race
 * condition where the iframe isn't ready when the open is attempted. The safe
 * approach is to listen for `widgetLoaded` first, then call widget.open().
 */
const loadAndOpen = () => {
    const conversations = window.HubSpotConversations;
    if (!conversations?.widget) return;

    const status = conversations.widget.status();

    if (!status.loaded) {
        const handleWidgetLoaded = () => {
            window.HubSpotConversations?.widget.open();
            window.HubSpotConversations?.off('widgetLoaded', handleWidgetLoaded);
        };
        conversations.on('widgetLoaded', handleWidgetLoaded);
        conversations.widget.load();
    } else {
        conversations.widget.open();
    }

    registerCloseListener();
};

export const useToggleHubspotChat = () => {
    const openChat = useCallback(() => {
        if (typeof window === 'undefined') return;

        if (!window.HubSpotConversations?.widget) {
            // API not ready yet — queue execution via hsConversationsOnReady
            window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), loadAndOpen];
            return;
        }

        loadAndOpen();
    }, []);

    return { openChat };
};

export default useToggleHubspotChat;
